import { OccConfig, OccEndpoints } from '@spartacus/core';

export const fluApiConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        getFluProducts:
          'users/${userId}/influenza/get-fluproducts-by-seasonId/${seasonId}',
        getFluProductsPBI:
          'users/${userId}/influenza/pbi/get-flu-products-by-seasonId/${seasonId}',
        getOrderHistory: 'users/${userId}/orders',
        getOrderDetails: 'users/${userId}/orders/${code}',
        getWholesalers: 'b2bUnits/getWholesalersByQueryText',
        getPharmacies: '/users/${userId}/influenza/search-pharmacy',
        setWholesaler:
          'b2bUnits/updateChosenB2BUnitForCurrentCustomerForInfluenzaCartEntries',
        setPharmacy: 'users/${userId}/influenza/setPharmacy',
        getReservationDetails: 'users/${userId}/quotes/${reservationCode}',
        approveReservation: 'users/${userId}/quotes/approve/${quoteCode}',
        rejectReservation: 'users/${userId}/quotes/reject/${quoteCode}',
        cancelReservation: 'users/${userId}/quotes/cancel/${quoteCode}',
        aknowledgeReservation:
          'users/${userId}/quotes/acknowledge/${quoteCode}',
        editReservation: 'users/${userId}/quotes/${quoteCode}/edit',
        getAllReservationsPharmacy:
          'users/${userId}/quotes/getQuotesForPharmacy',
        getAllReservationsPhysician:
          'users/${userId}/quotes/getQuotesForPhysician',
        fluOrderUpdateDetails:
          'users/${userId}/orders/${orderId}/flu-pre-order-update-config',
        sanitizeCart: 'users/${userId}/influenza/sanitize-cart',
        fluOrderUpdate: 'users/${userId}/orders/${orderCode}/flu-order-update',
        pharmacyAssociation: 'users/${userId}/carts/${cartId}/vouchers',
      } as OccEndpoints,
    },
  },
};
